import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: false,
    token: null,
    error: null,
};

const getBrainTreeTokenRequest = () => {
    return {
        token: null,
        error: null,
        loading: true,
    }
};

const getBrainTreeTokenSuccess = ( state, action ) => {
    return {
        token: action.token,
        error: null,
        loading: false,
    }
};

const getBrainTreeTokenFail = ( state, action ) => {
    return {
        token: null,
        error: action.error,
        loading: false,
    }
};

const clearBrainTreeErrors = () => {
    return {
        error: null
    }
};

export const braintreeReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.GET_BRAINTREE_TOKEN_REQUEST: return getBrainTreeTokenRequest();
        case actionTypes.GET_BRAINTREE_TOKEN_SUCCESS: return getBrainTreeTokenSuccess(state, action);
        case actionTypes.GET_BRAINTREE_TOKEN_FAIL: return getBrainTreeTokenFail(state, action);
        case actionTypes.CLEAR_ALL_ERRORS: return clearBrainTreeErrors();
        default:
            return state;
    }
};